import { useState, useEffect } from "react";
import LineChart from "./LineChart";
import { Chart, registerables } from 'chart.js';
import resultClass from './Results.module.css'
import { lineOptions } from "./Util";

Chart.register(...registerables);

function App({ allWPM, allErr, allInput, isMobile, resultIndex }) {
  const [lineData, setLineData] = useState({
    datasets: [
      {
        label: "WPM",
        data: allWPM.map((value, index) => [index + 1, parseInt(value)]),
        borderColor: "#50AF95",
        borderWidth: 2,
        fill: false, // Set to false to display only the line without filling the area underneath
        legend: {
          display: false,
        },
      },
      {
        label: "Error Rate (%)",
        data: allErr.map((value, index) => [index + 1, parseFloat(value)]),
        borderColor: "#FF6384",
        borderWidth: 2,
        borderDash: [5, 5], // dashed line for differentiation
        fill: false,
        yAxisID: "y1", //  separate axis if error rate scale differs
      }
    ],
  })

  const updateLineData = () => {
    let tempLineData = JSON.parse(JSON.stringify(lineData));
    tempLineData.datasets[0].data = allWPM.map((value, index) => [index + 1, parseInt(value)])
    tempLineData.datasets[1].data = allErr.map((value, index) => [index + 1, parseFloat(value)]);
    setLineData(tempLineData)
  }

  useEffect(() => {
    updateLineData()
  }, [allWPM])

  useEffect(() => {
    updateLineData()
  }, [resultIndex])


  return (
    <div>
      <div className={resultClass.lineGraphContainer}>
        <LineChart chartData={lineData} options={lineOptions(allWPM, allInput)} />
      </div>
    </div>
  );
}

export default App;
